import React from 'react'
import { Link } from 'gatsby'
import { Layout, Header, Showcase, SectionTitle } from '../../../../components'

import data from './data.json'
import modalImage from '../../../../images/wt-modal.png'
import scrollableImage from '../../../../images/wt-scrollable.png'
import InfoAlertModal from '../../../../images/infoalertmodal.png'
import WarningAlertModal from '../../../../images/WarningAlertModal.png'
import ErrorAlertModal from '../../../../images/ErrorAlertModal.png'

export default props => {
  const code = {
    scrollable: null,
    notScrollable: null,
    scrollableSticky: null,
    popUp: null,
  }

  const toggleDefault = () => {
    document.getElementsByTagName('body')[0].classList.toggle('u-scroll--none')
    document.getElementById('modal').classList.toggle('u-is-hidden')
  }

  const toggleScrollableSticky = () => {
    document.getElementsByTagName('body')[0].classList.toggle('u-scroll--none')
    document.getElementById('scrollable-sticky').classList.toggle('u-is-hidden')
  }

  const toggleInfoAlert = () => {
    document.getElementsByTagName('body')[0].classList.toggle('u-scroll--none')
    document.getElementById('InfoAlert').classList.toggle('u-is-hidden')
  }
  const toggleWarningAlert = () => {
    document.getElementsByTagName('body')[0].classList.toggle('u-scroll--none')
    document.getElementById('WarningAlert').classList.toggle('u-is-hidden')
  }
  const toggleErrorAlert = () => {
    document.getElementsByTagName('body')[0].classList.toggle('u-scroll--none')
    document.getElementById('ErrorAlert').classList.toggle('u-is-hidden')
  }

  //avoid activating toggle method when clicking in the modal
  const avoidPropagation = e => {
    e.stopPropagation()
  }

  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/design/'}
        state="design"
        title={data.title}
      />
      <Layout
        category="Overview"
        site={data.site}
        slug={data.slug + '/design/'}
        state="design"
        title={data.title}
      >
        <div class="intro">
          <p>
            Modals present contextual information or tasks without navigating
            the user away from the main task flow. Because they sit on an
            elevated layer and disable the layout behind them, they should be
            used for tasks and alerts that require the user's exclusive
            attention.
          </p>
        </div>
        <SectionTitle>Variants</SectionTitle>
        <h3>Standard Modal</h3>
        <Showcase
          site={data.site}
          text={
            <p>
              Standard modals constitue a continuation of a user's task flow and
              are the most used modal type. They allow the user to review
              information or take action.
              <br />
              <br />
              The required parts are a title, body content and associated
              actions. Body content in a modal may be plain text or contain
              interactive elements. Optionally, a standard modal may have a
              sub-header and a Close icon to dismiss the modal and return to the
              underlying screen.
            </p>
          }
        >
          <img
            class="l-margin-top--large"
            src={modalImage}
            width="100%"
            alt="Screenshot of modal component."
          />
          <div
            class="p-modal__overlay u-is-hidden"
            id="modal"
            onClick={toggleDefault}
            onKeyDown={toggleDefault}
            role="button"
            tabIndex={0}
          >
            <div
              class="p-modal"
              onClick={avoidPropagation}
              onKeyDown={avoidPropagation}
              role="button"
              tabIndex={0}
            >
              <div class="p-modal__close-bar">
                <h1 class="p-modal__close-bar-title">Header</h1>
                <button
                  class="p-modal__close-bar-button"
                  onClick={toggleDefault}
                  onKeyDown={toggleDefault}
                >
                  <i class="icon icon--close p-modal__close-bar-button-icon"></i>{' '}
                </button>
              </div>
              <div class="p-modal__content">
                Content Section
                <p class="l-margin-bottom--none">Lorem ipsum dolor</p>
              </div>
              <div class="p-modal__footer">
                <button class="p-modal__button">Button</button>
                <button class="p-modal__button--primary">Primary</button>
              </div>
            </div>
          </div>
          <button
            class="c-link l-margin-top--large"
            onClick={toggleDefault}
            onKeyDown={toggleDefault}
          >
            Open a Standard Modal{' '}
          </button>
        </Showcase>
        <h3>Alert Modal</h3>
        <p>
          Alert modals interrupt or end a user's task flow to give critical
          feedback about the action they're trying to take or force an immediate
          action. The required elements are a feedback icon, a title, body
          content and a way to dismiss the modal. Alert modals have no
          associated states.
        </p>
        <Showcase
          site={data.site}
          title="Information Alert Modal"
          text="Use information alert modals to direct the user on how to continue an interaction outside of the designed experience."
        >
          <img
            class="l-margin-top--large"
            src={InfoAlertModal}
            width="100%"
            alt="Screenshot of info alert modal component."
          />
          <div
            class="p-modal__overlay u-is-hidden"
            id="InfoAlert"
            onClick={toggleInfoAlert}
            onKeyDown={toggleInfoAlert}
            role="button"
            tabIndex={0}
          >
            <div
              class="p-modal-alert"
              onClick={avoidPropagation}
              onKeyDown={avoidPropagation}
              role="button"
              tabIndex={0}
            >
              <div class="p-modal-alert__close-bar">
                <button
                  class="p-modal__close-bar-button"
                  onClick={toggleInfoAlert}
                  onKeyDown={toggleInfoAlert}
                >
                  <i class="icon icon--close p-modal__close-bar-button-icon"></i>{' '}
                </button>
              </div>
              <div class="p-modal-alert__content">
                <i class="icon icon--info p-modal-alert__icon u-color--primary-base"></i>
                <div class="p-modal-alert__title">Need help?</div>
                <hr class="p-modal-alert__divider" />
                <div class="p-modal-alert__text">
                  If you're stuck, call one of our help desk representatives to
                  assist you in the process.
                </div>
              </div>
              <div class="p-modal__footer">
                <button class="p-modal__button--primary">Call Us</button>
              </div>
            </div>
          </div>
          <button
            class="c-link l-margin-top--large"
            onClick={toggleInfoAlert}
            onKeyDown={toggleInfoAlert}
          >
            Open an Info Alert Modal{' '}
          </button>
        </Showcase>
        <Showcase
          site={data.site}
          title="Warning Alert Modal"
          text={
            <p>
              Use warning alert modals to warn of destructive action and ask for
              immediate user confirmation in instances where the action will
              lead to data loss. If warning feedback does not require user
              confirmation, use the{' '}
              <Link to={'/' + data.site + '/components/notifications/design'}>
                Notifcation
              </Link>{' '}
              component instead.
            </p>
          }
        >
          <img
            class="l-margin-top--large"
            src={WarningAlertModal}
            width="100%"
            alt="Screenshot of warning alert modal component."
          />
          <div
            class="p-modal__overlay u-is-hidden"
            id="WarningAlert"
            onClick={toggleWarningAlert}
            onKeyDown={toggleWarningAlert}
            role="button"
            tabIndex={0}
          >
            <div
              class="p-modal-alert"
              onClick={avoidPropagation}
              onKeyDown={avoidPropagation}
              role="button"
              tabIndex={0}
            >
              <div class="p-modal-alert__close-bar">
                <button
                  class="p-modal__close-bar-button"
                  onClick={toggleWarningAlert}
                  onKeyDown={toggleWarningAlert}
                >
                  <i class="icon icon--close p-modal__close-bar-button-icon"></i>{' '}
                </button>
              </div>
              <div class="p-modal-alert__content">
                <i class="icon icon--exclamation p-modal-alert__icon u-color--semantic-orange-base"></i>
                <div class="p-modal-alert__title">
                  Are you sure you want to delete this address?
                </div>
                <hr class="p-modal-alert__divider" />
                <div class="p-modal-alert__text">
                  123 Park Ave Ormond Beach, FL 38477
                </div>
              </div>
              <div class="p-modal__footer">
                <button class="p-modal__button">Cancel</button>
                <button class="p-modal__button--primary">Confirm</button>
              </div>
            </div>
          </div>
          <button
            class="c-link l-margin-top--large"
            onClick={toggleWarningAlert}
            onKeyDown={toggleWarningAlert}
          >
            Open a Warning Alert Modal{' '}
          </button>
        </Showcase>
        <Showcase
          site={data.site}
          title="Error Alert Modal"
          text={
            <p>
              Use error alert modals to tell the user of an error that they
              cannot resolve on their own. Provide information within the body
              on how to proceed. If warning feedback is related to an action on
              the underlying page and can be fixed there, use the{' '}
              <Link to={'/' + data.site + '/components/notifications/design'}>
                Notifcation
              </Link>{' '}
              or{' '}
              <Link to={'/' + data.site + '/components/inline-error/design'}>
                Inline Error
              </Link>{' '}
              components instead. To communicate a system error, use a full-page
              error layout.
            </p>
          }
        >
          <img
            class="l-margin-top--large"
            src={ErrorAlertModal}
            width="100%"
            alt="Screenshot of warning alert modal component."
          />
          <div
            class="p-modal__overlay u-is-hidden"
            id="ErrorAlert"
            onClick={toggleErrorAlert}
            onKeyDown={toggleErrorAlert}
            role="button"
            tabIndex={0}
          >
            <div
              class="p-modal-alert"
              onClick={avoidPropagation}
              onKeyDown={avoidPropagation}
              role="button"
              tabIndex={0}
            >
              <div class="p-modal-alert__close-bar">
                <button
                  class="p-modal__close-bar-button"
                  onClick={toggleErrorAlert}
                  onKeyDown={toggleErrorAlert}
                >
                  <i class="icon icon--close p-modal__close-bar-button-icon"></i>{' '}
                </button>
              </div>
              <div class="p-modal-alert__content">
                <i class="icon icon--error p-modal-alert__icon u-color--semantic-red-base"></i>
                <div class="p-modal-alert__title">
                  Your account has been locked
                </div>
                <hr class="p-modal-alert__divider" />
                <div class="p-modal-alert__text">
                  You have made too many failed login attempts. Please contact
                  one of our help desk representatives for assistance.
                </div>
              </div>
            </div>
          </div>
          <button
            class="c-link l-margin-top--large"
            onClick={toggleErrorAlert}
            onKeyDown={toggleErrorAlert}
          >
            Open an Error Alert Modal{' '}
          </button>
        </Showcase>
        <hr />
        <SectionTitle>States</SectionTitle>

        <Showcase
          site={data.site}
          title="Scroll"
          text="In addition to the default state, which indicates that a modal is in the top scroll position or there is no scrollable content, Standard Modals with lengthy body content can use a scroll state. When scrolling, the header and optional sub-header, as well as the footer bar, will elevate and remain persistent at the top of the container with the rest of the content scrolling behind."
          code={code.scrollable}
        >
          <img
            src={scrollableImage}
            width="100%"
            alt="Screenshot of modal component."
          />

          <div>
            <div
              class="p-modal__overlay u-is-hidden"
              id="scrollable-sticky"
              onClick={toggleScrollableSticky}
              onKeyDown={toggleScrollableSticky}
              role="button"
              tabIndex={0}
            >
              <div
                class="p-modal"
                onClick={avoidPropagation}
                onKeyDown={avoidPropagation}
                role="button"
                tabIndex={0}
              >
                <div class="p-modal__close-bar">
                  <h1 class="p-modal__close-bar-title">Header</h1>
                  <button
                    class="p-modal__close-bar-button"
                    onClick={toggleScrollableSticky}
                    onKeyDown={toggleScrollableSticky}
                  >
                    <i class="icon icon--close p-modal__close-bar-button-icon"></i>{' '}
                  </button>
                </div>
                <div class="p-modal__sub-title">Optional sticky subtitle</div>
                <div class="p-modal__content">
                  Content Section
                  <p class="l-margin-bottom--none">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    Nullam pulvinar laoreet ligula in placerat. Quisque sed
                    lacinia nulla. Nullam nec nulla nec tortor suscipit
                    ullamcorper. Pellentesque dui dolor, varius sodales dolor
                    sed, bibendum eleifend lorem. Maecenas ut dui quis lacus
                    volutpat eleifend maximus a nisi. Curabitur lobortis
                    elementum risus nec tincidunt. Nunc at libero porta, pretium
                    velit non, interdum felis. Maecenas eget nulla accumsan,
                    suscipit justo at, facilisis turpis. Pellentesque mattis
                    justo eu tellus tempor posuere. Duis dignissim justo et
                    magna congue, ut tincidunt erat sollicitudin. Pellentesque
                    maximus pulvinar vestibulum. Aliquam erat volutpat. Nulla
                    lobortis ante a hendrerit lacinia. Phasellus non efficitur
                    nisl, eu malesuada ante. Nunc gravida eros vel sapien
                    egestas, ac pellentesque urna fermentum. Nulla vitae ligula
                    vel enim auctor ornare. Donec sit amet pharetra purus. Nunc
                    lesuada arcu congue sit amet. Ut tempus ex et turpis auctor,
                    id hendrerit felis volutpat. Curabitur elementum lacinia
                    malesuada. Curabitur sed condimentum mauris. Fusce molestie,
                    metus vel aliquet porta, odio lorem molestie ligula, sed
                    vehicula risus tortor et justo. Nunc elementum libero eu
                    condimentum scelerisque. Vestibulum tincidunt justo risus,
                    nec gravida diam tempor sit amet. Vestibulum ultrices diam
                    semper risus lobortis, a sodales metus accumsan.
                    Pellentesque habitant morbi tristique senectus et netus et
                    malesuada fames ac turpis egestas. Vestibulum diam erat,
                    tempus sit amet scelerisque et, vehicula non metus.
                    Curabitur tincidunt id lorem non porta. In sed neque a odio
                    fermentum pharetra eu sed neque. Cras justo tortor, aliquam
                    at metus eget, tincidunt hendrerit odio. Lorem ipsum dolor
                    sit amet, consectetur adipiscing elit. Nullam pulvinar
                    laoreet ligula in placerat. Quisque sed lacinia nulla.
                    Nullam nec nulla nec tortor suscipit ullamcorper.
                    Pellentesque dui dolor, varius sodales dolor sed, bibendum
                    eleifend lorem. Maecenas ut dui quis lacus volutpat eleifend
                    maximus a nisi. Curabitur lobortis elementum risus nec
                    tincidunt. Nunc at libero porta, pretium velit non, interdum
                    felis. Maecenas eget nulla accumsan, suscipit justo at,
                    facilisis turpis. Pellentesque mattis justo eu tellus tempor
                    posuere. Duis dignissim justo et magna congue, ut tincidunt
                    erat sollicitudin. Pellentesque maximus pulvinar vestibulum.
                    Aliquam erat volutpat. Nulla lobortis ante a hendrerit
                    lacinia. Phasellus non efficitur nisl, eu malesuada ante.
                    Nunc gravida eros vel sapien egestas, ac pellentesque urna
                    fermentum. Nulla vitae ligula vel enim auctor ornare. Donec
                    sit amet pharetra purus. Nunc lesuada arcu congue sit amet.
                    Ut tempus ex et turpis auctor, id hendrerit felis volutpat.
                    Curabitur elementum lacinia malesuada. Curabitur sed
                    condimentum mauris. Fusce molestie, metus vel aliquet porta,
                    odio lorem molestie ligula, sed vehicula risus tortor et
                    justo. Nunc elementum libero eu condimentum scelerisque.
                    Vestibulum tincidunt justo risus, nec gravida diam tempor
                    sit amet. Vestibulum ultrices diam semper risus lobortis, a
                    sodales metus accumsan. Pellentesque habitant morbi
                    tristique senectus et netus et malesuada fames ac turpis
                    egestas. Vestibulum diam erat, tempus sit amet scelerisque
                    et, vehicula non metus. Curabitur tincidunt id lorem non
                    porta. In sed neque a odio fermentum pharetra eu sed neque.
                    Cras justo tortor, aliquam at metus eget, tincidunt
                    hendrerit odio. Lorem ipsum dolor sit amet, consectetur
                    adipiscing elit. Nullam pulvinar laoreet ligula in placerat.
                    Quisque sed lacinia nulla. Nullam nec nulla nec tortor
                    suscipit ullamcorper. Pellentesque dui dolor, varius sodales
                    dolor sed, bibendum eleifend lorem. Maecenas ut dui quis
                    lacus volutpat eleifend maximus a nisi. Curabitur lobortis
                    elementum risus nec tincidunt. Nunc at libero porta, pretium
                    velit non, interdum felis. Maecenas eget nulla accumsan,
                    suscipit justo at, facilisis turpis. Pellentesque mattis
                    justo eu tellus tempor posuere. Duis dignissim justo et
                    magna congue, ut tincidunt erat sollicitudin. Pellentesque
                    maximus pulvinar vestibulum. Aliquam erat volutpat. Nulla
                    lobortis ante a hendrerit lacinia. Phasellus non efficitur
                    nisl, eu malesuada ante. Nunc gravida eros vel sapien
                    egestas, ac pellentesque urna fermentum. Nulla vitae ligula
                    vel enim auctor ornare. Donec sit amet pharetra purus. Nunc
                    lesuada arcu congue sit amet. Ut tempus ex et turpis auctor,
                    id hendrerit felis volutpat. Curabitur elementum lacinia
                    malesuada. Curabitur sed condimentum mauris. Fusce molestie,
                    metus vel aliquet porta, odio lorem molestie ligula, sed
                    vehicula risus tortor et justo. Nunc elementum libero eu
                    condimentum scelerisque. Vestibulum tincidunt justo risus,
                    nec gravida diam tempor sit amet. Vestibulum ultrices diam
                    semper risus lobortis, a sodales metus accumsan.
                    Pellentesque habitant morbi tristique senectus et netus et
                    malesuada fames ac turpis egestas. Vestibulum diam erat,
                    tempus sit amet scelerisque et, vehicula non metus.
                    Curabitur tincidunt id lorem non porta. In sed neque a odio
                    fermentum pharetra eu sed neque. Cras justo tortor, aliquam
                    at metus eget, tincidunt hendrerit odio.
                  </p>
                </div>
                <div class="p-modal__footer p-modal__footer--shadow">
                  <button class="p-modal__button">Button</button>
                  <button class="p-modal__button--primary">Primary</button>
                </div>
              </div>
            </div>
            <button
              class="c-link l-margin-top--large"
              onClick={toggleScrollableSticky}
              onKeyDown={toggleScrollableSticky}
            >
              Open a Modal in Scroll State{' '}
            </button>
          </div>
        </Showcase>
        <hr />
        <SectionTitle>Accessibility</SectionTitle>
        <p>
          Modals trap keyboard focus. Users must dismiss the modal, when
          possible, in order to return to the underlying page. Do not put
          information in a modal that necessitates the user interacting with
          information on the layout below. When the modal closes, focus should
          move back to the layout element that triggered it.
        </p>
        <hr />
        <SectionTitle>Design Environment</SectionTitle>
        <p>
          At larger breakpoints, modals take up 70% of the screen width, with a
          max-width of 710px. Modals can be dismissed in many ways: by clicking
          the scrim outside of the modal container, pressing the escape key,
          clicking the close icon or any dismissing action included in the
          modal. Modals should never trigger other modals.
        </p>
        <hr />
        <SectionTitle>Mircocopy</SectionTitle>
        <p>
          Modal titles should be concise and use key words to communicate a
          clear message. CTA text should be action driven and relate to the
          Modal title. Omit a CTA if the only available action is closing the
          modal. Instead, rely on the close icon.
        </p>
      </Layout>
    </>
  )
}
